import type { ReactNode } from 'react'
import { Tab, Tabs } from '@structural-climbing/ui'

interface Props<K extends string> {
  ariaLabel: string
  selectedKey: K
  onSelectionChange: (key: K) => void
  items: readonly { key: K; label: ReactNode }[]
  className?: string
}

/**
 * The one tab style for gym pages: HeroUI Tabs, scrolling sideways on a phone
 * rather than wrapping. Replaces the rows of gym-coloured buttons some pages
 * used, so every page switches views the same way.
 */
export function PageTabs<K extends string>({
  ariaLabel,
  selectedKey,
  onSelectionChange,
  items,
  className = 'mb-6',
}: Props<K>) {
  return (
    <Tabs
      aria-label={ariaLabel}
      selectedKey={selectedKey}
      onSelectionChange={(key) => onSelectionChange(String(key) as K)}
      className={className}
      classNames={{
        base: 'max-w-full',
        tabList: 'max-w-full flex-nowrap overflow-x-auto [scrollbar-width:none]',
      }}
    >
      {items.map((item) => (
        <Tab key={item.key} title={item.label} />
      ))}
    </Tabs>
  )
}
